import { render, staticRenderFns } from "./TheUserResourceAdmin.vue?vue&type=template&id=48aed52d&"
import script from "./TheUserResourceAdmin.vue?vue&type=script&lang=js&"
export * from "./TheUserResourceAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports